import { FormControl, InputLabel, MenuItem, Select, Autocomplete, TextField } from "@mui/material";
import get from "lodash.get";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

function SelectComponent(props) {
  const {
    menuItem = [],
    label,
    setSelections,
    required = false,
    procedureName = null,
    multiple = false,
    mode,
    minWidth = "120px",
  } = props;
  const [selection, setSelection] = useState(
    mode === "entity"
      ? {
        displayName: "Initimation Number",
        id: "INTIMATION_NUMBER",
      }
      : mode === "date"
        ? { id: "DATE_UPDATED", name: "Updated Date" }
        : ""
  );
  const handleChange = (event) => {
    setSelection(event.target.value);
  };
  const handleAutocompleteChange = (event, value) => {
    setSelection(value);
  };

  useEffect(() => {
    setSelections(selection);
  }, [selection]);

  return (
    <div>
      <FormControl
        variant="standard"
        fullWidth
        sx={{ m: 1, minWidth: minWidth }}
      >
        <InputLabel id="demo-simple-select-standard-label" required={required}>
          {label}
        </InputLabel>
        {!multiple && <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          label=""
          value={typeof selection === "object" ? selection.id : selection}
          onChange={handleChange}
          displayEmpty
        >
          {procedureName && (
            <MenuItem disabled value="">
              <p style={{ margin: 0, textAlign: "left" }}>{procedureName}</p>
            </MenuItem>
          )}

          {menuItem.length > 0 &&
            menuItem.map((item, index) => (
              <MenuItem
                value={
                  item.productCode ||
                  item.hospitalRoomName ||
                  item.illnessName ||
                  item.fileName ||
                  (item.id === 0 ? "0" : item.id) ||
                  item
                }
                key={index}
                style={{ padding: 8 }}
              >
                {" "}
                {item.productCode ||
                  item.name ||
                  item.displayName ||
                  item.hospitalRoomName ||
                  item.illnessName ||
                  item.fileName ||
                  item}
              </MenuItem>
            ))}
        </Select>}
        {multiple && <Autocomplete
          multiple
          id="tags-standard"
          sx={{mt: '1rem'}}
          options={menuItem}
          getOptionLabel={(option) => (`${get(option, ['illnessName'])} - ${get(option, ['defaultICDCode'])}`)}
          onChange={handleAutocompleteChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
            />
          )}
        />}
      </FormControl>
    </div>
  );
}

export default SelectComponent;
